import { RULES } from "./index";
import type { Rule, RuleContext, RuleFiring } from "./types";

/**
 * Runs every registered rule against the context. Pure: no I/O. Persistence
 * + dismissal handling lives in `useTodayRules` so the engine itself stays
 * trivially testable.
 */
export function runRules(ctx: RuleContext, rules: Rule[] = RULES): RuleFiring[] {
  const firings: RuleFiring[] = [];
  for (const rule of rules) {
    try {
      const f = rule.evaluate(ctx);
      if (f) firings.push(f);
    } catch (err) {
      // Don't let a single bad rule sink the run; log and continue.
      console.warn(`[rules] ${rule.id} threw`, err);
    }
  }
  return firings;
}
